var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from "styled-components";
import { AuthProvider } from "../../contexts/AuthContext";
import typography from "../../theme/foundations/typography";
import { color, shadow } from "../../theme/foundations/styles";
import breakpoints from "../../theme/foundations/mediaQueries";
import GlobalStyle from "../../theme/foundations/global";
import { Routes } from "../../routes";
import { TopHeader } from "../modules/TopHeader";
import { BaseContainer } from "./styles";
function App() {
    var theme = {
        typography: typography,
        color: color,
        shadow: shadow,
        breakpoints: breakpoints,
    };
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(AuthProvider, { children: [_jsx(GlobalStyle, {}), _jsxs(BaseContainer, { children: [_jsx(TopHeader, {}), _jsx(Routes, {})] })] }) })));
}
export default App;
